<template>
    <div @click="closeModal" style="background-color: #00000080; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div @click.stop="() => { }" style="width: 366px; background-color: #fff; border-radius: 20px; position: relative;">
            <div @click="closeModal" style="position: absolute; top: 20px; right: 20px;">
                <img style="width: 24px;" :src="require('@/assets/img/x_btn_circle_gray.png')" alt="">
            </div>
            <template v-if="event_type === EVENT_TYPE.WARNING">
                <div style="padding: 24px; text-align: center;">
                    <div style="margin-top: 6px; font-weight: 700; font-size: 28px; line-height: 32px; color: var(--color-main);">잠깐!</div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px; margin-top: 15px;">이벤트 응모를 놓치고 있어요</div>
                    <div style="margin-top: 20px; border-radius: 12px; box-shadow: 2px 2px 10px 0px #0000001A; background-color: #EBEBEB; color: #606060; padding: 8px 26px; font-weight: 500; font-size: 14px;">
                        <div style="line-height: 24px;">상단의 <span style="font-weight: 700; color: var(--color-main)">훈련 영상 업로드</span>를 켜고 영상을 올리면,<br>
                            국가대표 유니폼 등 푸짐한 선물을<br>
                            받을 수 있는 <span style="font-weight: 700; color: var(--color-main)">이벤트에 자동 응모</span>됩니다!
                        </div>
                        <div style="margin-top: 25px; line-height: 24px;">이벤트 참여 없이 일반 게시물로 등록하시겠어요?</div>
                    </div>
                    <div @click="showEventDetail" style="margin-top: 20px; text-decoration: underline; font-size: 14px; line-height: 24px;">이벤트 자세히 보기</div>
                    <div style="display: flex; gap: 18px; margin-top: 20px;">
                        <div @click="beforeCompleteAction" style="flex-basis: 34%; box-shadow: 1px 1px 3.8px 0px #0000001A; background-color: #ebebeb;" class="common_btn">그냥 등록할게요</div>
                        <div @click="closeModal" style="flex: 1; background-color: var(--color-main); color: #fff;" class="common_btn">훈련 영상으로 올리기</div>
                    </div>
                </div>
            </template>
            <template v-else-if="event_type === EVENT_TYPE.COMPLETE">
                <div style="padding: 24px; text-align: center;">
                    <div style="font-weight: 900; font-size: 24px; line-height: 32px;">이벤트 참여 완료 🎉</div>
                    <div style="margin-top: 20px; font-weight: 500; font-size: 14px; line-height: 24px; color: #808080;">훈련 영상이 성공적으로 업로드 되었습니다.<br>
                        <span style="color: var(--color-main); font-weight: 900; font-size: 16px;">이벤트 응모</span>가 정상 처리되었어요!
                    </div>
                    <div style="margin-top: 20px; border-radius: 12px; background-color: #efefef; display: flex; align-items: center; gap: 16px; padding: 16px 0;">
                        <div style="padding-left: 25px">
                            <img style="width: 64px;" :src="require('@/assets/img/event_icon.png')" alt="">
                        </div>
                        <div>
                            <div style="font-weight: 500; line-height: 24px; margin-bottom: 5px;">EVENT TICKET</div>
                            <div style="font-weight: 700; font-size: 24px; line-height: 24px; color: var(--color-main);">이벤트 응모완료</div>
                        </div>
                    </div>
                    <div @click="showEventDetail" class="common_btn" style="background-color: var(--color-main); color: #fff; margin-top: 20px; box-shadow: 0px 4px 0px 0px #BD4E03;">이벤트 홈으로</div>
                </div>
            </template>
            <template v-else-if="event_type === EVENT_TYPE.CONFIRM">
                <div style="padding: 24px; text-align: center;">
                    <div style="width: 88px; color: #fff; font-size: 12px; font-weight: 700; height: 32px; background-color: var(--color-main); border-radius: 12px; margin: 0 auto; line-height: 32px; text-align: center;">
                        CF 맞춤 훈련
                    </div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px; margin-top: 10px;">포지션 맞춤 훈련, 직접 도전해보세요!</div>
                    <div style="margin-top: 30px; font-weight: 500; line-height: 24px;">훈련 영상 업로드 한 번이면<br>🇰🇷국가대표 유니폼을 받을 기회까지 🎁</div>
                    <div style="margin-top: 15px; border-radius: 12px; height: 171px; background-color: #EBEBEB; overflow: hidden;">
                        <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + eventNotice.file_path" alt="">
                    </div>
                    <div @click="showEventDetail" style="margin-top: 25px; border-radius: 12px; height: 48px; line-height: 48px; text-align: center; font-weight: 700; color: #fff;  font-size: 14px; background-color: #111725">이벤트 확인하기</div>
                </div>
            </template>
            <template v-else-if="event_type === EVENT_TYPE.WRITE">
                <div style="padding: 24px; text-align: center;">
                    <div style="margin-top: 6px; font-weight: 700; font-size: 28px; line-height: 32px; color: var(--color-main);">잠깐!</div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px; margin-top: 15px;">이적시장에 입단 요청서를 작성하면<br>연락 올 확률이 더 높아요</div>
                    <div style="margin-top: 20px; border-radius: 12px; box-shadow: 2px 2px 10px 0px #0000001A; background: #FFC69F33; color: #606060; padding: 8px 22px; font-weight: 500; font-size: 14px;">
                        <div style="line-height: 24px;">엘리트 선수는 <span style="font-weight: 700; color: var(--color-main)">이적시장 페이지</span>에<br>
                            입단 요청서를 작성하시는 게<br>
                            감독님들에게 연락을 더 많이 받을 수 있습니다.
                        </div>
                        <div style="margin-top: 25px; line-height: 24px;">그래도 그라운드에 입단 요청서를 작성하시겠어요?</div>
                    </div>
                    <div @click="setChecked" style="margin-top: 20px; display: flex; justify-content: center; gap: 8px; align-items: center;">
                       <div :style="{ backgroundColor: checked ? 'var(--color-main)' : '#ebebeb' }" style="width: 18px; height: 18px; border-radius: 50%; display: flex; justify-content: center; align-items: center; background-color: #ebebeb;">
                            <img style="width: 10px;" :src="require('@/assets/img/white_check.png')" />
                        </div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 24px;">일주일 동안 보지 않기</div>
                    </div>
                    <div style="display: flex; gap: 18px; margin-top: 20px;">
                        <div @click="beforeShowWriteForm" style="flex-basis: 34%; box-shadow: 1px 1px 3.8px 0px #0000001A; background-color: #ebebeb;" class="common_btn">여기에 쓸게요</div>
                        <div @click="goSoccerJoin" style="flex: 1; background-color: var(--color-main); color: #fff;" class="common_btn">이적시장으로 가기</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

const EVENT_TYPE = {
    WARNING: 'warning',
    COMPLETE: 'complete',
    CONFIRM: 'confirm',
    WRITE: 'write'
}

export default {
    name: 'EventPopup',
    props: {
        event_type: {
            type: String,
            default: EVENT_TYPE.WARNING
        },
        notice_idx: {
            type: [Number, String],
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        },
        showWriteForm: {
            type: Function,
            default: () => {}
        },
        eventNoticeProp: {
            type: Object,
            default: () => {}
        }
    },
    created() {
        if (this.event_type === EVENT_TYPE.CONFIRM) {
            this.setEventNotice()
        }
    },
    data() {
        return {
            EVENT_TYPE: EVENT_TYPE,
            checked: false,
            eventNotice: null
        }
    },
    methods: {
        async setEventNotice() {
            this.eventNotice = this.eventNoticeProp
        },
        setChecked() {
            this.checked = !this.checked
        },
        showEventDetail() {
            this.$GlobalStore.closeLastModal()
            let notice_idx = this.event_type === EVENT_TYPE.CONFIRM ? this.eventNotice.idx : this.notice_idx
            this.$GlobalStore.addModal('NoticeDetail', { notice_idx: notice_idx, isClickOutside: true })
        },
        beforeCompleteAction() {
            localStorage.setItem('IS_CLOSE_EVENT_POPUP', true)
            this.$GlobalStore.closeLastModal()
            this.completeAction()
        },
        closeModal() {
            this.$GlobalStore.closeLastModal()
        },
        beforeShowWriteForm() {
            if (this.checked) {
                localStorage.setItem('HIDE_SEVEN_DAYS', moment().add(7, 'days').toISOString())
            }
            this.$GlobalStore.closeLastModal()
            this.showWriteForm()
        },
        goSoccerJoin() {
            if (this.checked) {
                localStorage.setItem('HIDE_SEVEN_DAYS', moment().add(7, 'days').toISOString())
            }
            this.$GlobalStore.closeLastModal()
            this.$router.push({ path: '/view/soccer_join' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        }
    },
}
</script>

<style scoped>
.upload_common_btn {
    width: 126px;
    height: 41px;
    line-height: 41px;
    text-align: center;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 500;
}

.common_btn {
    border-radius: 12px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
}
</style>